import { render, staticRenderFns } from "./MediaFileUploadDialog.vue?vue&type=template&id=e2961692"
import script from "./MediaFileUploadDialog.vue?vue&type=script&lang=js"
export * from "./MediaFileUploadDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports